import styled, { css } from 'styled-components';
import { getBouLinkStyle } from '../content/texts/bou-link';
import { BouColor } from '../global/bou-colors';
import { BouSpacingLevel, fluidSpacing } from '../layout/bou-spacing';
import { mobileOrNarrower, tabletOrWider } from '../layout/breakpoint-utils';
import UprightModelLogo from './icons/logo/upright-model-logo';

// TODO Refactor this hastily made combination of mobile footer and "About" modal to something that makes more sense
type Props = {
  onContactLinkPress: () => void;
};

export const AboutModalContentOrMobileFooter = ({ onContactLinkPress }: Props) => {
  return (
    <>
      <Root>
        <Row>
          <StyledLogo />
        </Row>
        <MobileOnlyContactRow>
          <FooterText>
            <FeedbackLink
              onClick={() => {
                onContactLinkPress();
              }}
            >
              Contact & Feedback
            </FeedbackLink>
          </FooterText>
        </MobileOnlyContactRow>
        <Row>
          <FooterText>
            <FooterLink href="https://www.uprightproject.com/terms-of-use" target="_blank">
              Terms of use
            </FooterLink>{' '}
            <FooterLink
              href="https://www.uprightproject.com/privacy-policy"
              target="_blank"
              style={{ marginLeft: '0.5em' }}
            >
              Privacy policy
            </FooterLink>{' '}
          </FooterText>
        </Row>
        <Row>
          {' '}
          <FooterText>
            The Upright Platform is built by{' '}
            <FooterLink href="https://www.uprightproject.com/" target="_blank">
              The&nbsp;Upright&nbsp;Project
            </FooterLink>
            .
          </FooterText>
        </Row>
        <Row>
          <FooterText>
            <FooterLink href="mailto:hello@uprightproject.com">hello@uprightproject.com</FooterLink>
            <br />
            Annankatu 27, 00100 Helsinki
            <br />© Upright Oy (2848353-4 Finland)
            <br />
          </FooterText>
        </Row>
        <Row>
          <PoweredByText>
            The service includes company data from{' '}
            <FooterLink href="https://www.demandbase.com/" target="_blank">
              Demandbase
            </FooterLink>
            .
          </PoweredByText>
        </Row>
      </Root>
    </>
  );
};

const Root = styled.div`
  ${mobileOrNarrower(
    css`
      border-top: 1px solid ${BouColor.TOOL_BORDER_DARK_GRAY};
      ${fluidSpacing('padding-top', BouSpacingLevel.SMALL)}
    `,
  )}
  ${fluidSpacing('padding-bottom', BouSpacingLevel.SMALL)}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: flex-end;
  margin: auto;
  font-size: 14px;
  color: ${BouColor.TOOL_TEXT_DARK_GRAY};

  & a {
    ${getBouLinkStyle()}
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  & + & {
    margin-top: 12px;
  }
`;

const MobileOnlyContactRow = styled(Row)`
  ${tabletOrWider(
    css`
      display: none;
    `,
  )}
`;

const StyledLogo = styled(UprightModelLogo)`
  width: 60%;
  ${fluidSpacing('padding-top', BouSpacingLevel.TINYISH)}
  ${fluidSpacing('margin-bottom', BouSpacingLevel.SMALL)}
`;

const FeedbackLink = styled.span`
  ${getBouLinkStyle(true)}
`;

const FooterText = styled.div`
  text-align: center;
  line-height: 1.71;
`;

const PoweredByText = styled(FooterText)`
  /* font-size: 10px; */
`;

const FooterLink = styled.a`
  ${getBouLinkStyle(true)}
`;
